import React from "react";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import {DropdownButton, MenuItem} from 'react-bootstrap';
import FontAwesome from "react-fontawesome";
import {kinetik_api_url} from '~/app/utilities';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {addViewBatches} from '../status_card_view/actions'
import axios from 'axios';
import toastr from 'toastr';
import MDSpinner from "react-md-spinner";

class StatusToolbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedDate: null,
      selectedPayer: "Payer",
      showSpinner: false,
    };
  }
 

  handleChange = date => {
    this.setState({ selectedDate: date })
    const bill_npi= localStorage.getItem('bill_npi');
    const token = localStorage.getItem('authToken');
    //const formattedDate= moment(date).format('YYYY-MM-DD');
    axios
    .post(kinetik_api_url + "/batch/bydate",{date,bill_npi,token})
    .then(response => {
      this.props.addViewBatches(response.data);
    })
    .catch(err => {
      console.log("/batch/bydate error:", err);
    });
    
  };
  handleSelectPayer = selectedVal => {
    const bill_npi= localStorage.getItem('bill_npi');
    const token = localStorage.getItem('authToken');
    let payerid;
    if(selectedVal==="All Payers"){
      payerid = "00000"
    }else{
      payerid = selectedVal.toString();
    }
    this.setState({ selectedPayer: selectedVal});
    axios
    .post(kinetik_api_url + "/batch/payerid",{payerid,bill_npi,token})
    .then(response => {
      this.props.addViewBatches(response.data);
    })
    .catch(err => {
      console.log("/batch/payerid error:", err);
    });
  }
 
  renderDropList() {
    const payers = JSON.parse(localStorage.getItem('payers'));
    payers.push({
      label: '',
      value: 'All Payers'
    })
    return payers.map(item => {
      return (
        <MenuItem key={item.value} eventKey={item.value}>
          {item.label+" "+item.value}</MenuItem>
      )
    })
  }

  getStatusUpdates = () => {
    this.setState({showSpinner:true})
    const token = localStorage.getItem('authToken');
    var requestURL = kinetik_api_url + "/batch/update?token="+token;
    axios
      .get(requestURL)
      .then(response => {
        this.setState({showSpinner:false})
        toastr.success(response.data.message)
      })
      .catch(err => {
        this.setState({showSpinner:false})
        toastr.error(err)
      });
  }
  render() {
    return (
        <div className="status-toolbar">
        <div className="input-group">
          {/* <p>Search By Date of Submission: </p> */}
          <span className="input-group-addon">
              <FontAwesome className="icon" name="calendar" />
          </span>
          <DatePicker
            className="datepicker-input"
            selected={this.state.selectedDate}
            onChange={this.handleChange}
          />
        </div>
        {/* <p>Search By Payer: </p> */}
        <DropdownButton className="dropdown-batch-status" title={this.state.selectedPayer} id={"dd-payer"}  onSelect={this.handleSelectPayer}>
        {this.renderDropList()}

        </DropdownButton>
        
        <button
          type="button"
          onClick={this.getStatusUpdates}
          className="btn btn-primary submit-btn right"
        >
          Check for Batch Updates
        </button>
        {this.state.showSpinner&&<MDSpinner/>}

      </div>
    );
  }
}
const mapStateToProps = state => {
  return {
  };
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      addViewBatches: addViewBatches,
    },
    dispatch
  );
}

export default connect(mapStateToProps,mapDispatchToProps)(StatusToolbar);

//selected={this.state.startDate} onChange={this.handleChange}

//const payers=["All Payers","Aetna - 60054","Fidelis Care New York - 11315","Metro Plus Health Plan - 13265",];



// WEBPACK FOOTER //
// ./src/app/batch_status/status_toolbar/StatusToolbar.js